/**
 * Mapping des catégories (valeurs DB) vers libellés français pour l'UI.
 * Les valeurs doivent correspondre au modèle backend pour éviter les erreurs de validation.
 */
export const CATEGORY_LABELS = {
  article: 'Article',
  professorPostBachelor: 'Publication Professeur (Licence)',
  professorPostMaster: 'Publication Professeur (Master)',
  innovation: 'Innovation',
  research: 'Recherche',
  news: 'Actualités',
  forAlumni: 'Pour les anciens élèves',
  blogOfStudents: 'Blog des étudiants',
  blogOfSpaceOfStudents: "Blog de l'espace étudiant",
  gamesAndEntertainment: 'Jeux et divertissement',
  entrepreneurship: 'Entreprenariat',
  leadership: 'Leadership',
  moocsDigitalLiteracy: 'MOOCs et littératie numérique',
  artificialIntelligence: 'Intelligence artificielle',
  womenEmpowerment: 'Autonomisation des femmes',
};

export const getCategoryLabel = (value) => CATEGORY_LABELS[value] || value;
